module.exports = __webpack_public_path__ + "img/book-open-reader-solid.2030de8e.svg";